export default __webpack_public_path__ + "static/media/15.e0b2f0bc.svg";